import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { VentasComponent } from '../ventas/ventas.component';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Personal } from 'src/app/Models/personal/personal';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { PrintVentasaClientesComponent } from '../../print/print-ventasa-clientes/print-ventasa-clientes.component';
import { VentasPorMesYClientesComponent } from '../../print/ventas-por-mes-yclientes/ventas-por-mes-yclientes.component';
import { PrintVentasPorClienteComponent } from '../../print/print-ventas-por-cliente/print-ventas-por-cliente.component';
import { PrintVentasPorVendedorComponent } from '../../print/print-ventas-por-vendedor/print-ventas-por-vendedor.component';
import { PrintVentasPorZonasComponent } from '../../print/print-ventas-por-zonas/print-ventas-por-zonas.component';
import { PrintVentasDiariasComponent } from '../../print/print-ventas-diarias/print-ventas-diarias.component';
import { PrintVentasDiariasDetalladoComponent } from '../../print-ventas-diarias-detallado/print-ventas-diarias-detallado.component';
import { PrintVentasPorCategoriaPreciosComponent } from '../../print-ventas-por-categoria-precios/print-ventas-por-categoria-precios.component';
import { PrintReporteGastosDetalladoComponent } from '../../print-reporte-gastos-detallado/print-reporte-gastos-detallado.component';
import { PrintVentasClienteAnualComponent } from '../../print/print-ventas-cliente-anual/print-ventas-cliente-anual.component';
import { Filtros } from 'src/app/Models/filtro/filtros';

@Component({
  selector: 'app-ventas-clientes',
  templateUrl: './ventas-clientes.component.html',
  styleUrls: ['./ventas-clientes.component.css']
})
export class VentasClientesComponent implements OnInit {
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild(PrintVentasaClientesComponent, null) printventas: PrintVentasaClientesComponent;
  //Nuevo Reporte print
  @ViewChild(PrintVentasClienteAnualComponent, null) printVentasAnual: PrintVentasClienteAnualComponent;
  @ViewChild(PrintVentasPorClienteComponent, null) printventasporcliente: PrintVentasPorClienteComponent;
  @ViewChild(VentasPorMesYClientesComponent, null) printreporteanual: VentasPorMesYClientesComponent;
  @ViewChild(PrintVentasPorVendedorComponent, null) printventasporvendedor: PrintVentasPorVendedorComponent;
  @ViewChild(PrintVentasPorZonasComponent, null) printventasporzona: PrintVentasPorZonasComponent;
  @ViewChild(PrintVentasDiariasComponent, null) print_ventasdiarias: PrintVentasDiariasComponent;
  @ViewChild(PrintVentasDiariasDetalladoComponent, null) print_ventasdiarias_det: PrintVentasDiariasDetalladoComponent;
  @ViewChild(PrintVentasPorCategoriaPreciosComponent, null) printventascatprecio: PrintVentasPorCategoriaPreciosComponent;

  public usuario: Usuario = new Usuario();
  public rangofechas: RangoFechas = new RangoFechas();
  public listameses = [
    { nombre: 'Enero', numero: 1 },
    { nombre: 'Febrero', numero: 2 },
    { nombre: 'Marzo', numero: 3 },
    { nombre: 'Abril', numero: 4 },
    { nombre: 'Mayo', numero: 5 },
    { nombre: 'Junio', numero: 6 },
    { nombre: 'Julio', numero: 7 },
    { nombre: 'Agosto', numero: 8 },
    { nombre: 'Septiembre', numero: 9 },
    { nombre: 'Octubre', numero: 10 },
    { nombre: 'Noviembre', numero: 11 },
    { nombre: 'Diciembre', numero: 12 }
  ];
  public listapersonal: Personal[] = []
  public articulos: any[] = []
  public zonas: any[] = []
  public filtro: Filtro = new Filtro();
  public tipoinforme = 6;
  public funcion: Function = null;
  public isShow: boolean = false;
  public pagina: number = 0;
  public modal = "modal-lg";
  public zindex: number = 10000;
  public cliente: Cliente = new Cliente;
  public listclientes: Cliente[] = [];
  public alertType: AlertType = new AlertType();
  public sucursal: number;

  public listaFiltro: Filtros = new Filtros();
  public tiposClienteSeleccionados: number[] = [];
  public tiposBalonSeleccionados: number[] = [];

  constructor(private data: DataService, private route: Router, private auth: AuthService) {
    this.usuario = this.auth.getCurrentUser();
    this.getClientes();
    this.getFiltros();
    this.filtro.fecini = this.formatearFechas(new Date());
    this.filtro.fecfin = this.formatearFechas(new Date());
  }

  ngOnInit() {

  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.showTab(1);
    this.setInitialDates();
    this.sucursal = parseInt(this.data.getSucursalId())
    setTimeout(() => {
      this.btnshow.nativeElement.click();
      this.getlistaPersonal()
      this.getProductos()
      this.GetZonasUbigeo()
      // this.usuario.idpersonal.idnivel == 1 ? this.tipoinforme = 6: this.tipoinforme = 5
      this.info.hide();
    }, 10);
  }

  showTab(i) {
    this.pagina = i;
    if (this.pagina == 1) { this.modal = 'modal-lg'; }
    else { this.modal = ''; }
  }


  setInitialDates() {
    const today = new Date();
    this.rangofechas.fecfin = this.formatearFechas(today);

    // Obtener el primer día del mes
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.rangofechas.fecini = this.formatearFechas(firstDayOfMonth);
  }

  formatearFechas(fecha) {
    const parsedDate = moment(fecha, 'DD-MM-YYYY');
    fecha = parsedDate.format('YYYY-MM-DD');
    return fecha;
  }

  setRango() {
    let fechainicio = this.formatearFechas(this.rangofechas.fecini);
    let fechafin = this.formatearFechas(this.rangofechas.fecfin);
    this.rangofechas.fecini = fechainicio;
    this.rangofechas.fecfin = fechafin;
  }

  getlistaPersonal() {
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      this.listapersonal = r
    })
  }

  getProductos() {
    this.data.GetSimple(this.data.api.articulos).subscribe((r) => {
      this.articulos = r;
    })
  }

  GetZonasUbigeo() {
    this.data.GetSimple(this.data.api.ubicacion).subscribe(r => {

      this.zonas = r;
      console.log(this.zonas);
    });
  }

  imprimirVenta() {

    if (this.tipoinforme == 1) {
      this.printventasporvendedor.mes = this.filtro.mes
      this.printventasporvendedor.idvende = this.filtro.idvende
      this.printventasporvendedor.onMonthSelect()
      this.printventasporvendedor.GetData()
      this.printventasporvendedor.sumacantidad = 0
      setTimeout(() => {
        this.printventasporvendedor.printerVentas()
      }, 2000);
    } else if (this.tipoinforme == 0) {
      const filtrosReporte = {
        año: new Date().getFullYear(),  // o this.filtro.año si lo tienes
        tipo_cliente_id: this.filtro.tipo_cliente_id || 0,
        tipo_balon_id: this.filtro.tipo_balon_id || 0
      };

      console.log('📤 Generando reporte anual con filtros:', filtrosReporte);

      // Llamar al componente de impresión
      this.printVentasAnual.GetData(filtrosReporte);




    } else if (this.tipoinforme == 3) {
      //this.route.navigate(['printer/ventasclientesporproducto/'+this.filtro.idproduct]);
      this.printreporteanual.idproducto = this.filtro.idproduct
      this.printreporteanual.sucursal = this.sucursal
      this.printreporteanual.GetData()

      setTimeout(() => {
        this.printreporteanual.printerVentas()
      }, 2000);
    } else if (this.tipoinforme == 2) {
      this.printventasporzona.mes = this.filtro.mes
      this.printventasporzona.ubigeo = this.filtro.ubigeo
      this.printventasporzona.onMonthSelect()
      const rep = this.printventasporzona.GetData()
      this.printventasporzona.sumacantidad = 0

    } else if (this.tipoinforme == 4) {

      this.printventasporcliente.mes = this.filtro.mes;
      this.printventasporcliente.sucursal = this.sucursal
      this.printventasporcliente.onMonthSelect()
      this.printventasporcliente.GetData()
      this.printventasporcliente.sumacantidad = 0

    } else if (this.tipoinforme == 5) {

      if (!this.filtro.fecini || !this.filtro.fecfin) {
        this.data.notify("Seleccione fecha de inicio y fin", "Error", this.alertType.error);
        return
      }

      this.filtro.idsucursal = this.sucursal
      const respuesta = this.print_ventasdiarias.GetData(this.filtro);

    }
    else if (this.tipoinforme == 6) {
      if (this.usuario.idpersonal.idnivel != 1) {
        // No admin: forzar reporte solo del día de hoy
        this.filtro.fecini = this.formatearFechas(new Date());
        this.filtro.fecfin = this.formatearFechas(new Date());
      } else if (!this.filtro.fecini || !this.filtro.fecfin) {
        this.data.notify("Seleccione fecha de inicio y fin", "Error", this.alertType.error);
        return;
      }

      this.filtro.idsucursal = this.sucursal
      const respuesta = this.print_ventasdiarias_det.GetData(this.filtro);
    }
    else if (this.tipoinforme == 7) {
      this.printventascatprecio.mes = this.filtro.mes;
      this.printventascatprecio.sucursal = this.sucursal
      // this.printventascatprecio.onMonthSelect()
      this.printventascatprecio.GetData()

      // this.filtro.idsucursal = this.sucursal
      // const respuesta = this.print_ventasdiarias_det.GetData(this.filtro);
    }

  }

  async getClientes() {
    console.log("obteniendo clientes");
    await this.data.AsyncGetSimple(this.data.api.cliente).then(r => {
      this.listclientes = r;
    })
  }

  async getFiltros(){
    await this.data.AsyncGetSimple(this.data.api.filtro).then(r => {
      console.log("asddddddddddddddddddddddddddddd", r)
      this.listaFiltro = r;
    })
  }

  close() {
    this.btnclose.nativeElement.click();
  }

  GenerarExcel() {
    let ruta = ""
    if (this.tipoinforme == 1) {
      ruta = this.data.api.detfactura;
    } else if (this.tipoinforme == 0) {
      ruta = this.data.api.factura;
    }
    this.data.GenerateExcel(ruta, this.rangofechas).subscribe(r => {
      console.log(r);

      if (r.download_url) {
        window.open(this.data.api.apiBaseUrl + 'api/download_excel' + r.download_url, '_blank');
        // Establecer un retraso antes de eliminar el archivo
        setTimeout(() => {
          this.data.DeleteExcel(r.download_url).subscribe(r => console.log(r));
        }, 20000); // 10000 milisegundos = 10 segundos
      }
    }, (error) => {
      this.data.notify("Error al generar excel", "Error", this.alertType.error);
    });
  }
}
